import { apiPost } from './client';
import type { LoginResponse, RefreshResponse, RegisterResponse } from './types';

// 권위: docs/ARCH_DASHBOARD.md §6.2 [인증]
// Spring Jackson 기본값 = camelCase. Java 필드 providerId / accessToken 그대로.

export interface LoginArgs {
  email: string;
  password: string;
  providerId?: string;
}

export function login(args: LoginArgs): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/api/v1/auth/login', {
    providerId: args.providerId ?? 'email_password',
    email: args.email,
    password: args.password,
  });
}

export interface RegisterArgs {
  email: string;
  password: string;
  name: string;
}

export function register(args: RegisterArgs): Promise<RegisterResponse> {
  return apiPost<RegisterResponse>('/api/v1/auth/register', args);
}

export function resendVerification(email: string): Promise<void> {
  return apiPost<void>('/api/v1/auth/resend-verification', { email });
}

export function forgotPassword(email: string): Promise<void> {
  return apiPost<void>('/api/v1/auth/forgot-password', { email });
}

export function resetPassword(token: string, newPassword: string): Promise<void> {
  return apiPost<void>('/api/v1/auth/reset-password', { token, newPassword });
}

export function refresh(): Promise<RefreshResponse> {
  return apiPost<RefreshResponse>('/api/v1/auth/refresh');
}

export function logout(): Promise<void> {
  return apiPost<void>('/api/v1/auth/logout');
}
